import React from 'react';
import { useEffect } from 'react';
import { useState } from 'react';

export const CustomPagination = ({
    count,
    page,
    rowsPerPage,
    onPageChange,
}) => {
    const totalPages = Math.max(1, Math.ceil(count / rowsPerPage));

    const isFirstPage = page === 1;
    const isLastPage = page >= totalPages;

    const [inputValue, setInputValue] = useState(page);

    // Icônes simples Unicode
    const FirstPageIcon = () => <span style={{ fontSize: 14 }}>&#171;</span>;  // «
    const LastPageIcon = () => <span style={{ fontSize: 14 }}>&#187;</span>;   // »
    const LeftArrowIcon = () => <span style={{ fontSize: 14 }}>&#8592;</span>; // ←
    const RightArrowIcon = () => <span style={{ fontSize: 14 }}>&#8594;</span>; // →

    useEffect(() => {
        setInputValue(page);
    }, [page]);

    return (
    <tfoot style={{overflow: 'hide'}}>
        <tr>
            <td colSpan="100%" style={{textAlign: 'center' }}>
                <div className='pagination-button-container' >
                    <button
                        onClick={() => onPageChange(1)}
                        disabled={isFirstPage}
                        aria-label="first page"
                        className={isFirstPage ? 'pagination-button-disabled' : 'pagination-button'}
                    >
                        <FirstPageIcon />
                    </button>

                    <div className='pagination-separator' />

                    <button
                        onClick={() => onPageChange(page - 1)}
                        disabled={isFirstPage}
                        aria-label="previous page"
                        className={isFirstPage ? 'pagination-button-disabled' : 'pagination-button'}
                    >
                        <LeftArrowIcon />
                    </button>

                    <div className={'pagination-separator'} />

                    <div className="flex items-center gap-2">
                        <input
                            type="number"
                            value={inputValue}
                            onChange={(e) => {
                                const val = e.target.value;
                                setInputValue(val);
                                const parsed = parseInt(val, 10);
                                if (!isNaN(parsed) && parsed >= 1 && parsed <= totalPages) {
                                    onPageChange(parsed);
                                }
                            }}
                            min={1}
                            max={totalPages}
                            className="pagination-input"
                        />
                        <span className="text-sm font-semibold">/ {totalPages}</span>
                    </div>

                    <div className={'pagination-separator'} />

                    <button
                        onClick={() => onPageChange(page + 1)}
                        disabled={isLastPage}
                        aria-label="next page"
                        className={isLastPage ? 'pagination-button-disabled' : 'pagination-button'}
                    >
                       <RightArrowIcon />
                    </button>

                    <div className={'pagination-separator'} />

                    <button
                        onClick={() => onPageChange(totalPages)}
                        disabled={isLastPage}
                        aria-label="last page"
                        className={isLastPage ? 'pagination-button-disabled' : 'pagination-button'}
                    >
                        <LastPageIcon />
                    </button>
                </div>
            </td>
        </tr>
    </tfoot>
    );
};
